import { render } from "./MyTask.vue?vue&type=template&id=1b65da65&scoped=true"
import script from "./MyTask.vue?vue&type=script&lang=js"
export * from "./MyTask.vue?vue&type=script&lang=js"

import "./MyTask.vue?vue&type=style&index=0&id=1b65da65&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b65da65"]])

export default __exports__